module.exports = __webpack_public_path__ + "static/img/wmdemo.cf11a62.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wmdemo.png
// module id = VStK
// module chunks = 4